/**
 * Consent-gated analytics loader for theme-owned scripts.
 * Follows Shopify Customer Privacy (native cookie banner).
 */
(function () {
  var GA_ID = 'G-KEP9M0X2C4';
  var MOUSEFLOW_ID = '2d2928a0-6eea-4b37-ae33-18c5c0572ffb';
  var analyticsLoaded = false;
  var initialized = false;

  function getPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    }
  }

  function analyticsAllowed() {
    var privacy = getPrivacy();
    if (!privacy) return false;

    if (typeof privacy.analyticsProcessingAllowed === 'function') {
      return privacy.analyticsProcessingAllowed();
    }

    var consent = typeof privacy.getTrackingConsent === 'function'
      ? privacy.getTrackingConsent()
      : '';

    if (consent === 'yes') return true;
    if (consent === 'no') return false;

    return typeof privacy.userCanBeTracked === 'function' && privacy.userCanBeTracked();
  }

  function marketingAllowed() {
    var privacy = getPrivacy();
    if (!privacy) return false;

    if (typeof privacy.marketingAllowed === 'function') {
      return privacy.marketingAllowed();
    }

    var consent = typeof privacy.getTrackingConsent === 'function'
      ? privacy.getTrackingConsent()
      : '';

    if (consent === 'yes') return true;
    if (consent === 'no') return false;

    return typeof privacy.userCanBeTracked === 'function' && privacy.userCanBeTracked();
  }

  function updateGoogleConsent() {
    ensureGtag();

    var analyticsState = analyticsAllowed() ? 'granted' : 'denied';
    var marketingState = marketingAllowed() ? 'granted' : 'denied';

    window.gtag('consent', 'update', {
      analytics_storage: analyticsState,
      ad_storage: marketingState,
      ad_user_data: marketingState,
      ad_personalization: marketingState
    });
  }

  function loadGoogleAnalytics() {
    if (document.getElementById('peachade-ga-script')) return;

    ensureGtag();
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);

    var script = document.createElement('script');
    script.id = 'peachade-ga-script';
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(script);
  }

  function loadMouseflow() {
    if (document.getElementById('peachade-mouseflow-script')) return;

    window._mfq = window._mfq || [];
    var script = document.createElement('script');
    script.id = 'peachade-mouseflow-script';
    script.defer = true;
    script.src = 'https://cdn.mouseflow.com/projects/' + MOUSEFLOW_ID + '.js';
    document.head.appendChild(script);
  }

  function enableAnalytics() {
    updateGoogleConsent();
    if (!analyticsAllowed()) return;

    if (!analyticsLoaded) {
      analyticsLoaded = true;
      loadGoogleAnalytics();
      loadMouseflow();
    }
  }

  function applyConsent() {
    updateGoogleConsent();
    if (analyticsAllowed()) {
      enableAnalytics();
    }
  }

  function bindConsentEvents() {
    document.addEventListener('trackingConsentAccepted', applyConsent);
    document.addEventListener('visitorConsentCollected', applyConsent);
  }

  function init() {
    if (initialized) return;
    initialized = true;

    ensureGtag();
    bindConsentEvents();

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      applyConsent();
      return;
    }

    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1',
      onLoad: applyConsent
    }]);

    setTimeout(applyConsent, 2000);
  }

  window.peachadeConsent = {
    applyConsent: applyConsent,
    analyticsAllowed: analyticsAllowed,
    marketingAllowed: marketingAllowed
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
